import { trackPageview } from '@/helpers/tracking'
import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'


// SPA route changes don't reload the page, so pageviews must be fired manually.
export function usePageTracking() {
  const location = useLocation()

  useEffect(() => {
    // mirrors the old gtag exclude: ["/preview/**"]
    if (location.pathname.startsWith('/preview')) return
    trackPageview(location.pathname + location.search)
  }, [location.pathname, location.search])
}
